import { useStoreApi } from '@xyflow/react';
import { useCallback } from 'react';

/**
 * Returns a getter for the current viewport center in flow coordinates.
 * Use this when placing a new node where the user is currently looking,
 * regardless of pan/zoom.
 */
export function useGetFlowViewportCenter() {
  const store = useStoreApi();
  return useCallback(() => {
    const { transform, width, height } = store.getState();
    const [x, y, zoom] = transform;
    return {
      x: (width / 2 - x) / zoom,
      y: (height / 2 - y) / zoom,
    };
  }, [store]);
}
